import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Image from "../assets/Info.jpg";
import { NavLink } from "react-router-dom";

const Info = () => {
  return (
    <Container fluid>
      <Row>
        <Col lg={6} xs={12} className="mb-3 mt-4">
          <h1>Security used to be an inconvenience, now it's a Necessity</h1>
          <p className="mt-5">
            At IDM 360 Analytics, we take pride in redefining the standards of IT security every single day. With innovation, groundbreaking strategies, and world-class solutions at the core of everything we do, we deliver excellence in every engagement.</p>

<p>What sets us apart is our deep understanding of the underlying business objectives that drive the need for robust Information security solutions. This unique approach, combined with a proven track record of success in managing large and complex environments, forms the foundation of our unwavering commitment to excellence. Recognized for our transformative approach and Industry leadership.</p>
IDM 360 Analytics is not just your partner in IT Security. We are your gateway to a Safer and more innovative Digital future. Our mission is to ensure your growth and Success in an increasingly connected world.

          
          <div>
            <Button
              className="hover-right"
              as={NavLink} to={"/contact"}
              style={{
                borderRadius: "25px",
                backgroundColor: "#002D62",
                height: "25px",
                padding: "0px 5px 0px 5px",
              }}
            >
              More About us &rarr;
            </Button>
          </div>
        </Col>
        <Col lg={6} xs={12}>
          <img
            className="img-fluid mt-4"
            src={Image}
            // style={{ height: "400px", margin: "21px 0 21px 0" }}
            alt="Info"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Info;
